import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import http from 'utils/http';
import { setErrorWithoutSnack } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  pending: false,
  response: {},
};

const reducers = {
  acceptPtoError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  acceptPtoPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  acceptPtoReset() {
    return initialState;
  },
  acceptPtoResetError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  acceptPtoSuccess(state, { payload }) {
    return R.assoc('response', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'acceptPto',
  reducers,
});

export const {
  acceptPtoPending,
  acceptPtoSuccess,
  acceptPtoError,
  acceptPtoReset,
  acceptPtoResetError,
} = actions;

// Actions
let acceptController;
export function sendAcceptPto(params = {}) {
  return dispatch => {
    dispatch(acceptPtoPending(true));
    if (acceptController) acceptController.abort();
    acceptController = new AbortController();
    const { signal } = acceptController;
    return http
      .post('/product-transfer-orders/accept', params, { signal })
      .then(res => {
        dispatch(acceptPtoError(''));
        dispatch(acceptPtoSuccess(res.data));
        dispatch(acceptPtoPending(false));
      })
      .catch(error => {
        setErrorWithoutSnack(error, dispatch, acceptPtoError);
      });
  };
}

export function resetAcceptPtoError() {
  return dispatch => {
    dispatch(acceptPtoResetError(null));
  };
}

export default reducer;
